import { render, staticRenderFns } from "./create-product-feature.vue?vue&type=template&id=aa0f6234&scoped=true&"
import script from "./create-product-feature.vue?vue&type=script&lang=js&"
export * from "./create-product-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0f6234",
  null
  
)

export default component.exports